var d = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, r = {}, i = d && d.__assign || function() {
  return i = Object.assign || function(e) {
    for (var n, o = 1, a = arguments.length; o < a; o++) {
      n = arguments[o];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
    }
    return e;
  }, i.apply(this, arguments);
};
r.__esModule = !0;
function c(e, n) {
  if (!n)
    return "";
  var o = "; " + e;
  return n === !0 ? o : o + "=" + n;
}
function C(e) {
  if (typeof e.expires == "number") {
    var n = /* @__PURE__ */ new Date();
    n.setMilliseconds(n.getMilliseconds() + e.expires * 864e5), e.expires = n;
  }
  return c("Expires", e.expires ? e.expires.toUTCString() : "") + c("Domain", e.domain) + c("Path", e.path) + c("Secure", e.secure) + c("SameSite", e.sameSite);
}
function f(e, n, o) {
  return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(n).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + C(o);
}
r.encode = f;
function u(e) {
  for (var n = {}, o = e ? e.split("; ") : [], a = /(%[\dA-F]{2})+/gi, t = 0; t < o.length; t++) {
    var l = o[t].split("="), s = l.slice(1).join("=");
    s.charAt(0) === '"' && (s = s.slice(1, -1));
    try {
      var m = l[0].replace(a, decodeURIComponent);
      n[m] = s.replace(a, decodeURIComponent);
    } catch {
    }
  }
  return n;
}
r.parse = u;
function p() {
  return u(document.cookie);
}
r.getAll = p;
function v(e) {
  return p()[e];
}
r.get = v;
function g(e, n, o) {
  document.cookie = f(e, n, i({ path: "/" }, o));
}
r.set = g;
function h(e, n) {
  g(e, "", i(i({}, n), { expires: -1 }));
}
r.remove = h;
const y = (e) => {
  const n = JSON.parse(decodeURIComponent(e));
  return n.ctc ? n.ctc.v1 ? n.ctc.v1 : [] : [];
}, x = "userContext", w = (e) => {
  try {
    return A().includes(e);
  } catch (n) {
    console.warn("ctc-reader in isTreatmentEnabled failed.", n);
  }
}, A = () => {
  const e = r.get(x);
  return e ? y(e) : (console.warn("ctc-reader: Context cookie are missing. If you are developing locally check the readme;)"), []);
};
export {
  w as isTreatmentEnabled
};
//# sourceMappingURL=contact-channels57.js.map
